import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import HeaderAddress from './header-address';
import { InputGroup, Input } from 'reactstrap';
import moment from 'moment';
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';

import { getCredentials } from '../../selectors/application';
import {
  editMessage,
  draftClean,
  selectMessage,
  setShowUserSignPopover,
  setShowUserTemplatePopover
} from '../../actions/application';
import {
  getOneEntity,
  getFilesDocument,
  dataUrlToFile
} from '../../services/accounts';
import { getFolders } from '../../services/folder';
import { sendMessage, saveDraft } from '../../services/smtp';
import { getAddresses } from '../../services/message-addresses';
import {
  deleteMessages,
  resetFolderMessagesCache
} from '../../services/message';
import { persistApplicationNewMessageContent } from '../../services/indexed-db';
import Spinner from '../spinner/spinner';
import '../../app.scss';
import ACTIONS from '../../actions/lexon';
import { Notification, Confirmation } from '../notification/';
import { fileExtensionTypes, FORBIDDEN_EXTENSIONS } from '../../constants';
import ComboBoxComponent from '../combobox/ComboBoxComponent';
import ComposeMessageEditor from './composeMessageEditor';
import AttachmentCard from '../attachment/attachment-card';

const MAX_TOTAL_ATTACHMENTS_SIZE = 20971520;
const PERSIST_DEBOUNCE_MS = 2000;

class MessageEditor extends Component {
  constructor(props) {
    super(props);
    const signOptions = [
      ...(this.props.lexon?.firmas || []),
      ...[
        { isDefault: false, name: 'Enviar sin firma', sign: '' },
        { isDefault: false, name: 'Nueva firma', sign: '' }
      ]
    ];
    const templateOptions = [
      ...(this.props.lexon?.templates || []),
      ...[
        { isDefault: false, name: 'Enviar sin plantilla', template: '' },
        { isDefault: false, name: 'Nueva plantilla', template: '' }
      ]
    ];
    this.state = {
      linkDialogVisible: false,
      linkDialogUrl: '',
      dropZoneActive: false,
      editorState: {},
      messageNotification: '',
      errorNotification: '',
      notificationAlign: 'center',
      showNotification: false,
      messageConfirmation: '',
      showConfirmation: false,
      isDraftEdit: false,
      draftId: '',
      closeButton: true,
      isLoadingCount: false,
      showSpinner: false,
      isPriority: false,
      readConfirmation: false,
      receiptConfirmation: false,
      headerCollapsed: false,
      templateOptions,
      selectedTemplate:
        templateOptions.find(template => template.isDefault) ||
        templateOptions.find(
          template => template.name === 'Enviar sin plantilla'
        ),
      signOptions,
      selectedSign:
        signOptions.find(sign => sign.isDefault) ||
        signOptions.find(sign => sign.name === 'Enviar sin firma'),
      localInterveners: (this.props.interveners
        ?.filter(intervener => intervener.email)
        ?.map(x => `${x.name?.replace(/,/g, '') || ''}, ${x.role?.replace(/,/g, '') || ''}, ${x.email || ''}`)) || [],
      displayExpandedCompose: true,
      showEmptySubjectWarning: false,
      showEmptyDestintationWarning: false,
      allowEmptySubject: false
    };

    this.sendingMessage = false;
    this.fileInput = null;
    this.editorRef = React.createRef();
    this.headerFormRef = React.createRef();
    this.composeRef = React.createRef();
    this.containerPanelRef = React.createRef();
    this.attachmentWrapperRef = React.createRef();
    this.handleSetState = patchedState => this.setState(patchedState);
    this.handleSubmit = this.submit.bind(this);
    this.handleDraft = this.saveDraft.bind(this);
    this.handleRemoveDraft = this.removeDraft.bind(this);
    // Global events
    this.handleOnDrop = this.onDrop.bind(this);
    this.handleOnDragOver = this.onDragOver.bind(this);
    this.handleOnDragLeave = this.onDragLeave.bind(this);
    // Header Address Events
    this.handleAddAddress = this.addAddress.bind(this);
    this.handleRemoveAddress = this.removeAddress.bind(this);
    this.handleMoveAddress = this.moveAddress.bind(this);
    // Subject events
    this.handleOnSubjectChange = this.onSubjectChange.bind(this);
    // Editor events
    this.handleEditorChange = this.editorChange.bind(this);
    this.onAttachButton = this.onAttachButton.bind(this);
    this.onAttachSelected = this.onAttachSelected.bind(this);
    this.attachFromLexon = this.attachFromLexon.bind(this);
    this.onSignChange = this.onSignChange.bind(this);
    this.onTemplateChange = this.onTemplateChange.bind(this);
    this.handleGetUserFromLexonConnector =
      this.handleGetUserFromLexonConnector.bind(this);
    this.resizeObserver = null;
    this.persistTimer = null;
    this.lastEditorContent = null;
  }

  componentDidMount() {
    const { application, editedMessage } = this.props;
    const { selectedMessage } = application;
    if (!selectedMessage) {
      this.props.newMessage();
    }
    if (this.fileInput) {
      this.fileInput.onchange = this.onAttachSelected;
    }
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('OpenComposer'));
    }, 500);
    window.addEventListener('AttachDocument', this.attachFromLexon);
    window.addEventListener(
      'GetUserFromCentinelaConnector',
      this.handleGetUserFromLexonConnector
    );

    const { interveners } = this.props;
    this.setState({
      localInterveners: (interveners
        ?.filter(intervener => intervener.email)
        ?.map(x => `${x.name?.replace(/,/g, '') || ''}, ${x.role?.replace(/,/g, '') || ''}, ${x.email || ''}`)) || []
    });

    if (
      selectedMessage &&
      Object.keys(selectedMessage).length > 0 &&
      ((this.props.application.selectedFolderId &&
        this.props.draftFolderbyName &&
        this.props.application.selectedFolderId ===
          this.props.draftFolderbyName.folderId) ||
        (this.props.application.selectedFolderId &&
          this.props.draftFolderbyAttribute &&
          this.props.application.selectedFolderId ===
            this.props.draftFolderbyAttribute.folderId))
    ) {
      this.getMessageById(selectedMessage);
    }

    // Set the subject if the message is repply or forward
    if (selectedMessage && editedMessage && editedMessage.subject) {
      this.setState({ subject: this.props.editedMessage.subject });
    }

    const { documentsId, bbdd, idCompany, lexonToken } = this.props.lexon;
    const { idUser, env } = this.props.currentUser;

    if (documentsId) {
      this.setState({ showSpinner: true });
      if (documentsId && documentsId.length > 0) {
        const getDocumentLexon = async () => {
          try {
            for (let index = 0; index < documentsId.length; index++) {
              const documentId = documentsId[index];
              const documentData = await getFilesDocument(
                bbdd,
                idCompany,
                idUser,
                documentId,
                env,
                lexonToken
              );
              const getDocumentInfo = await getOneEntity(
                bbdd,
                idCompany,
                idUser,
                documentId,
                env,
                lexonToken
              );
              const dataUrl = documentData.data;
              const documentDataInfo = getDocumentInfo.data;
              const blob = dataUrlToFile({
                dataUrl,
                mimeType: documentDataInfo.code.split('.')[1]
              });
              const fileOfBlob = new File([blob], documentDataInfo.name);
              if (fileOfBlob.size > MAX_TOTAL_ATTACHMENTS_SIZE) {
                this.showNotification(
                  i18n.t('messageEditor.max-file-size'),
                  false
                );
              } else {
                const newAttachment = {
                  fileName: documentDataInfo.initialFile,
                  size: fileOfBlob.size,
                  content: `${dataUrl}`
                };
                const updatedMessage = { ...this.props.editedMessage };
                updatedMessage.attachments = updatedMessage.attachments
                  ? [...updatedMessage.attachments, newAttachment]
                  : [newAttachment];
                const sum = updatedMessage.attachments.reduce(
                  (accumulator, attachment) => accumulator + attachment.size,
                  0
                );

                if (sum >= MAX_TOTAL_ATTACHMENTS_SIZE) {
                  this.showNotification(
                    i18n.t('messageEditor.max-file-size'),
                    false
                  );
                  return;
                }

                this.props.editMessage(updatedMessage);
              }
            }
            this.setState({ showSpinner: false });
            this.props.setDocumentsId(null);
          } catch {
            this.props.setDocumentsId(null);
          }
        };
        getDocumentLexon();
      }
    }
    this.props.setSubmitMethod(this.handleSubmit);
    this.props.setAddAttachmentMethod(this.onAttachButton);
    this.props.setAddDraftMethod(this.handleDraft);

    const composeElement = this.composeRef.current;
    const MIN_TOOLBAR_WIDTH_PX = 1200; // Define the minimum toolbar width

    // Create a ResizeObserver to observe the toolbar's size
    this.resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (entry.contentRect.width < MIN_TOOLBAR_WIDTH_PX) {
          this.setState({ displayExpandedCompose: false });
        } else {
          this.setState({ displayExpandedCompose: true });
        }
      }
    });

    // Start observing the toolbar element
    if (composeElement) {
      this.resizeObserver.observe(composeElement);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.props.lexon?.firmas?.length !== prevProps.lexon?.firmas?.length) {
      const signOptions = [
        ...(this.props.lexon?.firmas || []),
        ...[
          { isDefault: false, name: 'Enviar sin firma', sign: '' },
          { isDefault: false, name: 'Nueva firma', sign: '' }
        ]
      ];
      this.setState({
        signOptions,
        selectedSign:
          signOptions.find(sign => sign.isDefault) ||
          signOptions.find(sign => sign.name === 'Enviar sin firma')
      }, () => {
        if (this.state.selectedSign &&
          prevState.selectedSign &&
          this.state.selectedSign.name !== prevState.selectedSign.name) {
          this.onSignChange(this.state.selectedSign.name);
        }
      });
    }

    if (
      this.props.lexon.templates.length !== prevProps.lexon.templates.length
    ) {
      const templateOptions = [
        ...(this.props.lexon?.templates || []),
        ...[
          { isDefault: false, name: 'Enviar sin plantilla', template: '' },
          { isDefault: false, name: 'Nueva plantilla', template: '' }
        ]
      ];
      this.setState({
        templateOptions,
        selectedTemplate:
          templateOptions.find(template => template.isDefault) ||
          templateOptions.find(template => template.name === 'Enviar sin plantilla')
      }, () => {
        if (this.state.selectedTemplate &&
          prevState.selectedTemplate &&
          this.state.selectedTemplate.name !== prevState.selectedTemplate.name) {
          this.onTemplateChange(this.state.selectedTemplate.name);
        }
      });
    }

    if (this.props.application.outbox !== prevProps.application.outbox) {
      //A message has been sent
      const { draftFolderbyName, draftFolderbyAttribute } = this.props;
      const draftFolder = draftFolderbyAttribute
        ? draftFolderbyAttribute
        : draftFolderbyName;

      if (
        this.props.application.outbox &&
        this.props.application.outbox.sent === true
      ) {
        if (
          this.props.draft !== null ||
          (draftFolder &&
            draftFolder.folderId &&
            this.props.application.selectedFolderId === draftFolder.folderId)
        ) {
          //Sent message was a draft. Manually deleting message from draft folder.
          this.props.deleteMessage(
            this.props.credentials,
            draftFolder,
            this.props.selectedMessageEdit,
            this.props.lexon
          );
          this.props.editMessage(null);
          this.props.messageClean();
          this.props.draftClean();
          this.sendingMessage = false;
          this.props.close(this.props.application);
        } else {
          this.props.editMessage(null);
          this.props.messageClean();
          this.props.draftClean();
          this.sendingMessage = false;
          this.props.close(this.props.application);
        }
      } else if (
        this.props.application.outbox &&
        this.props.application.outbox.error
      ) {
        // PEC-8747: el envío falló (p. ej. SMTP rechazó la contraseña): conservar el mensaje y desbloquear el editor
        this.sendingMessage = false;
        this.setState({ showSpinner: false, closeButton: true });
      }
    }

    if (prevProps.draft !== this.props.draft) {
      if (this.props.draft && this.props.draft?.sent === true) {
        // Draft has been sent
        const { draftFolderbyAttribute, draftFolderbyName } = this.props;
        const draftFolder = draftFolderbyAttribute
          ? draftFolderbyAttribute
          : draftFolderbyName;

        if (this.state.draftId !== '') {
          this.props.deleteMessage(
            this.props.credentials,
            draftFolder,
            this.props.selectedMessageEdit,
            this.props.lexon
          );
        }

        const folderPromise = this.props.reloadFolders(this.props.credentials);
        const messagePromise = this.props.reloadMessageCache(
          this.props.application.user,
          draftFolder
        );
        await Promise.all([folderPromise, messagePromise]);

        const { draft } = this.props;
        const { msgCache } = this.props;

        const createdMessage = Array.from(
          Object.entries(msgCache[draftFolder.folderId]),
          ([key, value]) => ({ key, value })
        ).find(f => f.value.messageId === draft.idMessage);

        this.setState({ showNotification: false, messageNotification: '' });
        this.props.selectMessage(createdMessage.value);
        this.updateAttachmentLinks(createdMessage.key);

        const fullTime = this.getTimeDraft();
        if (this.state.draftId !== '') {
          if (
            this.props.toastObj &&
            this.props.toastObj.element &&
            document.body.contains(this.props.toastObj.element)
          ) {
            this.props.toastObj.hide('All');
            this.props.toastObj.show({
              content: i18n.t('messageEditor.draft-edited'),
              cssClass: 'e-toast-success',
              icon: 'lf-icon lf-icon-check-round'
            });
          }
          this.props.draftTime.current = fullTime;
          this.setState({
            showSpinner: false,
            closeButton: true,
            draftId: this.props.draft.idMessage
          });
        } else {
          if (
            this.props.toastObj &&
            this.props.toastObj.element &&
            document.body.contains(this.props.toastObj.element)
          ) {
            this.props.toastObj.hide('All');
            this.props.toastObj.show({
              content: i18n.t('messageEditor.draft-created'),
              cssClass: 'e-toast-success',
              icon: 'lf-icon lf-icon-check-round'
            });
          }
          this.props.draftTime.current = fullTime;
          this.setState({
            showSpinner: false,
            closeButton: true,
            draftId: this.props.draft.idMessage
          });
        }
        this.props.draftClean();
      } else if (this.props.draft && this.props.draft.error === true) {
        if (
          this.props.toastObj &&
          this.props.toastObj.element &&
          document.body.contains(this.props.toastObj.element)
        ) {
          this.props.toastObj.hide('All');
          this.props.toastObj.show({
            content: i18n.t('messageEditor.draft-error'),
            cssClass: 'e-toast-danger',
            icon: 'lf-icon lf-icon-close-round'
          });
        }
        this.setState({
          showSpinner: false,
          closeButton: true
        });
        this.props.draftClean();
      }
    }
    // We edit the compose with the original content of the message (inline images may take longer to be available)
    if (
      this.props.selectedMessageEdit &&
      this.props.selectedMessageEdit.content &&
      this.props.selectedMessageEdit.content !==
        prevProps.selectedMessageEdit.content
    ) {
      this.getContentEdit(this.props.selectedMessageEdit.content);
    } else if (
      this.props.editedMessage &&
      this.props.selectedMessageEdit &&
      (this.props.editedMessage.content === '<br/><br/><br/><br/>' ||
        this.props.editedMessage.content === '' ||
        this.props.editedMessage.content === null) &&
      this.props.selectedMessageEdit.content !== null
    ) {
      const defaultSign = this.props.lexon.firmas?.find(sign => sign.isDefault);

      const defaultTemplate = this.props.lexon.templates?.find(
        template => template.isDefault
      );

      let currentContent = this.props.selectedMessageEdit.content;

      if (defaultSign) {
        currentContent = `<p><br></p><p><br></p><p><br></p><p><br></p><p>${defaultSign.sign}</p>${currentContent}`;
      }

      if (defaultTemplate) {
        currentContent =
          `<p>${defaultTemplate.template}</p>` + currentContent;
      }

      this.getContentEdit(currentContent?.replace('undefined', ''));
    }
    // This is to load attachment links when they're ready
    if (
      this.props.selectedMessageEdit &&
      this.props.selectedMessageEdit?.attachments !==
        prevProps.selectedMessageEdit?.attachments
    ) {
      if (
        this.props.editedMessage &&
        (this.props.editedMessage.attachments === null ||
          this.props.editedMessage.attachments === undefined ||
          this.props.editedMessage.attachments.length === 0)
      ) {
        this.getAttachmentsEdit(this.props.selectedMessageEdit.attachments);
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(this.persistTimer);
    window.removeEventListener('AttachDocument', this.attachFromLexon);
    window.removeEventListener(
      'GetUserFromCentinelaConnector',
      this.handleGetUserFromLexonConnector
    );

    const composeElement = this.composeRef.current;

    // Stop observing the toolbar element
    if (composeElement && this.resizeObserver) {
      this.resizeObserver.unobserve(composeElement);
    }
  }

  typeAllowed(file) {
    const fileName = file?.name || '';
    const lastDotIndex = fileName.lastIndexOf('.');

    // No extension (or hidden file like ".env"): allow it.
    if (lastDotIndex <= 0) {
      return true;
    }

    const ext = fileName.substring(lastDotIndex + 1).trim().toLowerCase();
    const normalizedForbiddenExtensions = FORBIDDEN_EXTENSIONS.map(extension =>
      extension.replace(/^\./, '').trim().toLowerCase()
    );

    return !normalizedForbiddenExtensions.includes(ext);
  }

  onTogglePriority = () => {
    const { isPriority } = this.state;
    this.setState({ isPriority: !isPriority });
  };

  onToggleReadConfirmation = () => {
    const { readConfirmation } = this.state;
    this.setState({ readConfirmation: !readConfirmation });
  };

  onToogleReceiptConfirmation = () => {
    const { receiptConfirmation } = this.state;
    this.setState({ receiptConfirmation: !receiptConfirmation });
  };

  handleGetUserFromLexonConnector() {
    window.dispatchEvent(new CustomEvent('OpenComposer'));
  }

  getContentEdit(value) {
    const updatedMessage = { ...this.props.editedMessage };

    if (value !== undefined) {
      setTimeout(() => {
        this.props.editMessage({ ...updatedMessage, content: value });
      }, 100);
    }
  }

  getAttachmentsEdit(value) {
    const updatedMessage = { ...this.props.editedMessage };
    this.props.editMessage({ ...updatedMessage, attachments: value });
  }

  attachFromLexon(event) {
    const length = event.detail.content.length;

    const addAttachment = detail => {
      const newAttachment = {
        fileName: detail.document.code,
        size: length,
        content: detail.content
      };
      const updatedMessage = { ...this.props.editedMessage };
      updatedMessage.attachments = updatedMessage.attachments
        ? [...updatedMessage.attachments, newAttachment]
        : [newAttachment];
      this.props.editMessage(updatedMessage);
    };
    addAttachment(event.detail);
  }

  confirmRemoveMessageEditor(application) {
    const newMessage = application.newMessage;
    const emptyMesage = {
      to: [],
      cc: [],
      bcc: [],
      attachments: [],
      subject: '',
      content: '<br/><br/><br/><br/>'
    };

    if (JSON.stringify(newMessage) === JSON.stringify(emptyMesage)) {
      this.removeMessageEditor(application);
    } else {
      const { draftId } = this.state;
      const draftSent =
        this.props.application &&
        this.props.application.draft &&
        this.props.application.draft.sent;
      if (draftId !== '' || draftSent) {
        this.setState({
          showConfirmation: true,
          messageConfirmation: '¿Quiere eliminar el borrador definitivamente?'
        });
      } else {
        this.setState({
          showConfirmation: true,
          messageConfirmation: '¿Quiere descartar el mensaje actual?'
        });
      }
    }
  }

  removeMessageEditor(application) {
    const { close, lexon } = this.props;

    if (lexon.idCaseFile !== null && lexon.idCaseFile !== undefined) {
      window.dispatchEvent(new CustomEvent('RemoveCaseFile'));
      this.props.setCaseFile({
        casefile: null,
        bbdd: null,
        idCompany: null
      });
    }

    if (lexon.mailContacts) {
      this.props.setMailContacts(null);
    }
    this.props.draftClean();
    this.props.messageClean();
    close(application);
  }

  acceptConfirmation() {
    const { draftId } = this.state;
    if (draftId !== '') {
      this.handleRemoveDraft();
    }
    this.setState({ showConfirmation: false });
    this.removeMessageEditor(this.props.application);
    this.props.setDocumentsId(null);
  }

  cancelConfirmation() {
    this.setState({ showConfirmation: false });
  }

  onSignChange(value) {
    if (value === 'Nueva firma') {
      this.props.setShowUserSignPopover(true);
      return;
    }

    const selectedSign = this.state.signOptions.find(
      sign => sign.name === value
    );

    let currentContent = this.props.content;

    const newSign = selectedSign?.sign
      ? `<p>${selectedSign.sign}</p>`
      : '<span/>';

    const lastIndex = (currentContent || '').lastIndexOf(
      `<p>${this.state.selectedSign.sign}</p>`
    );

    if (lastIndex === -1) {
      currentContent = `${currentContent}${newSign}`;
    } else {
      currentContent =
        currentContent.substring(0, lastIndex) +
        newSign +
        currentContent.substring(
          lastIndex + `<p>${this.state.selectedSign.sign}</p>`.length
        );
    }
    this.getContentEdit(currentContent);
    this.setState({
      selectedSign
    });
  }

  onTemplateChange(value) {
    if (value === 'Nueva plantilla') {
      this.props.setShowUserTemplatePopover(true);
      return;
    }

    const selectedTemplate = this.state.templateOptions.find(
      template => template.name === value
    );

    let currentContent = this.props.content;

    const newTemplate = selectedTemplate?.template
      ? `<p>${selectedTemplate.template}</p>`
      : '<span/>';

    const lastIndex = (currentContent || '').lastIndexOf(
      `<p>${this.state.selectedTemplate.template}</p>`
    );

    if (lastIndex === -1) {
      currentContent = `${newTemplate}${currentContent}`;
    } else {
      currentContent =
        newTemplate +
        currentContent.substring(0, lastIndex) +
        currentContent.substring(
          `<p>${this.state.selectedTemplate.template}</p>`.length +
          lastIndex
        );
    }

    this.getContentEdit(currentContent);
    this.setState({
      selectedTemplate
    });
  }

  renderDocumentType = props => {
    const extension = props.fileName?.split('.').pop().toLowerCase();

    if (extension === fileExtensionTypes.word) {
      return (
        <img
          src={`/assets/images/icon-microsoft-word.svg`}
          alt=""
          width="17px"
          height="17px"
        />
      );
    }

    if (extension === fileExtensionTypes.pdf) {
      return (
        <img
          src={`/assets/images/icon-microsoft-pdf.svg`}
          alt=""
          width="17px"
          height="17px"
        />
      );
    }

    if (
      extension === fileExtensionTypes.jpg ||
      extension === fileExtensionTypes.png
    ) {
      return (
        <img
          src={`/assets/images/icon-microsoft-img.svg`}
          alt=""
          width="17px"
          height="17px"
        />
      );
    }

    if (extension === fileExtensionTypes.excel) {
      return (
        <img
          src={`/assets/images/icon-microsoft-excel.svg`}
          alt=""
          width="17px"
          height="17px"
        />
      );
    }

    if (extension === fileExtensionTypes.ppt) {
      return (
        <img
          src={`/assets/images/icon-microsoft-ppt.svg`}
          alt=""
          width="17px"
          height="17px"
        />
      );
    }

    if (extension === fileExtensionTypes.txt) {
      return (
        <i className="lf-icon lf-icon-document text-color-blue-lefebvre" />
      );
    }

    return <i className="lf-icon lf-icon-document text-color-blue-lefebvre" />;
  };

  render() {
    const {
      to,
      cc,
      bcc,
      attachments,
      content,
      interveners,
      subjectEmail,
    } = this.props;

    const {
      showNotification,
      messageNotification,
      notificationAlign,
      showConfirmation,
      messageConfirmation,
      showSpinner,
      isPriority,
      readConfirmation,
      receiptConfirmation,
      localInterveners,
      displayExpandedCompose,
      showEmptySubjectWarning,
      showEmptyDestintationWarning,
      subject,
    } = this.state;

    return (
      <Fragment>
        <Confirmation
          initialModalState={showNotification}
          onCancel={() => {
            this.fileInput.value = '';
            this.setState({ showNotification: false });
          }}
          message={messageNotification}
          align={notificationAlign}
          titleCancel={i18n.t('general.close')}
          confirmType="confirm-info"
          iconType="lf-icon lf-icon-information"
        />
        <Confirmation
          initialModalState={showConfirmation}
          onAccept={() => {
            this.acceptConfirmation();
          }}
          onCancel={() => {
            this.cancelConfirmation();
          }}
          titleAccept="Aceptar"
          titleCancel="Cancelar"
          message={messageConfirmation}
        />
        <Confirmation
          initialModalState={showEmptySubjectWarning}
          onAccept={() => {
            this.setState({ allowEmptySubject: true }, () => {
              this.submit();
            });
          }}
          onCancel={() => {
            this.setState({ showEmptySubjectWarning: false });
          }}
          message={i18n.t('messageEditor.no-subject-warning')}
          titleAccept={i18n.t('general.accept')}
          titleCancel={i18n.t('general.cancel')}
          confirmType="confirm-info"
          iconType="lf-icon lf-icon-information"
        />
        <Confirmation
          initialModalState={showEmptyDestintationWarning}
          onAccept={() => {
            this.setState({ showEmptyDestintationWarning: false });
          }}
          onCancel={() => null}
          message={i18n.t('messageEditor.min-dest-alert')}
          titleAccept={i18n.t('general.close')}
          confirmType="confirm-info"
          iconType="lf-icon lf-icon-information"
        />
        <Spinner
          visible={showSpinner}
          className={'spinner'}
          pathClassName={'spinnerPath'}
        />
        <div className="compose-dialog" ref={this.composeRef}>
          <div className="d-flex justify-content-end mb-3 header-content">
            <div className="priority-wrapper">
              <CheckBoxComponent
                value={isPriority}
                id={this.props.id}
                label={i18n.t('messageEditor.mark-prioritary')}
                change={this.onTogglePriority}
                checked={isPriority}
              />
            </div>
            <div className="priority-wrapper">
              <CheckBoxComponent
                value={readConfirmation}
                id={this.props.id}
                label={i18n.t('messageEditor.read-confirmation')}
                change={this.onToggleReadConfirmation}
                checked={readConfirmation}
              />
            </div>
            <div className="priority-wrapper">
              <CheckBoxComponent
                value={receiptConfirmation}
                id={this.props.id}
                label={i18n.t('messageEditor.receipt-confirmation')}
                change={this.onToogleReceiptConfirmation}
                checked={receiptConfirmation}
              />
            </div>
            {displayExpandedCompose && (
              <>
                <div className="sign-input-group">
                  <div className="sign-combobox-label">
                    {i18n.t('account-sign.signature')}
                  </div>
                  <div className="sign-combobox">
                    <ComboBoxComponent
                      onChange={this.onSignChange}
                      dataSource={this.state.signOptions}
                      value={this.state.selectedSign || ''}
                      showCloseButton={false}
                    />
                  </div>
                </div>
                <div className="sign-input-group">
                  <div className="sign-combobox-label">
                    {i18n.t('email-template.template')}
                  </div>
                  <div className="sign-combobox">
                    <ComboBoxComponent
                      onChange={this.onTemplateChange}
                      dataSource={this.state.templateOptions}
                      value={this.state.selectedTemplate || ''}
                      showCloseButton={false}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          <div
            className="container-panel"
            ref={this.containerPanelRef}
            onDrop={this.handleOnDrop}
            onDragOver={this.handleOnDragOver}
            onDragLeave={this.handleOnDragLeave}
          >
            {this.state.dropZoneActive && (
              <div className="dropZone">
                <div className="dropZoneMessage">
                  {i18n.t('messageEditor.drag-and-drop')}
                </div>
              </div>
            )}
            <div className="compose-message">
              <form ref={this.headerFormRef} className="message-fields">
                {interveners?.length > 0 && (
                  <HeaderAddress
                    id={'lexon'}
                    addresses={localInterveners}
                    interveners={interveners
                      ?.filter(intervener => intervener.email)
                      ?.map(x => `${x.name?.replace(/,/g, '') || ''}, ${x.role?.replace(/,/g, '') || ''}, ${x.email || ''}`)}
                    onAddressAdd={this.handleAddAddress}
                    onAddressRemove={this.handleRemoveAddress}
                    onAddressMove={() => {}}
                    getAddresses={this.props.getAddresses}
                    label={i18n.t('messageEditor.lexon')}
                    currentUser={this.props.currentUser}
                    lexonToken={this.props.lexon.lexonToken}
                  />
                )}
                <HeaderAddress
                  id={'to'}
                  addresses={to}
                  onAddressAdd={this.handleAddAddress}
                  onAddressRemove={this.handleRemoveAddress}
                  onAddressMove={this.handleMoveAddress}
                  getAddresses={this.props.getAddresses}
                  label={i18n.t('messageEditor.to')}
                  currentUser={this.props.currentUser}
                  lexonToken={this.props.lexon.lexonToken}
                />

                <HeaderAddress
                  id={'cc'}
                  addresses={cc}
                  onAddressAdd={this.handleAddAddress}
                  onAddressRemove={this.handleRemoveAddress}
                  onAddressMove={this.handleMoveAddress}
                  getAddresses={this.props.getAddresses}
                  label={i18n.t('messageEditor.cc')}
                  currentUser={this.props.currentUser}
                  lexonToken={this.props.lexon.lexonToken}
                />
                <HeaderAddress
                  id={'bcc'}
                  addresses={bcc}
                  onAddressAdd={this.handleAddAddress}
                  onAddressRemove={this.handleRemoveAddress}
                  onAddressMove={this.handleMoveAddress}
                  getAddresses={this.props.getAddresses}
                  label={i18n.t('messageEditor.bcc')}
                  currentUser={this.props.currentUser}
                  lexonToken={this.props.lexon.lexonToken}
                />
                <InputGroup>
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      {i18n.t('messageEditor.subject')}
                    </span>
                  </div>
                  <Input
                    placeholder=""
                    defaultValue={subject || subjectEmail}
                    onChange={this.handleOnSubjectChange}
                  />
                  {isPriority && (
                    <div className="important-input-addon">
                      <img
                        style={{ width: '13px' }}
                        src="/assets/icons/settings/important.svg"
                        alt="important"
                      />
                    </div>
                  )}
                </InputGroup>
                {!displayExpandedCompose && (
                  <>
                    <div className="sign-input-group sign-input-group-compact">
                      <div className="sign-combobox-label">
                        {i18n.t('account-sign.signature')}
                      </div>
                      <div className="sign-combobox">
                        <ComboBoxComponent
                          onChange={this.onSignChange}
                          dataSource={this.state.signOptions}
                          value={this.state.selectedSign || ''}
                          showCloseButton={false}
                        />
                      </div>
                    </div>
                    <div className="sign-input-group sign-input-group-compact">
                      <div className="sign-combobox-label">
                        {i18n.t('email-template.template')}
                      </div>
                      <div className="sign-combobox">
                        <ComboBoxComponent
                          onChange={this.onTemplateChange}
                          dataSource={this.state.templateOptions}
                          value={this.state.selectedTemplate || ''}
                          showCloseButton={false}
                        />
                      </div>
                    </div>
                  </>
                )}
              </form>
              {attachments && attachments.length > 0 && (
                <div
                  className="attachment-wrapper"
                  ref={this.attachmentWrapperRef}
                >
                  <div className="attachments-container">
                    {attachments.map((item, index) => (
                      <AttachmentCard
                        i={index}
                        key={index}
                        attachment={item}
                        attachments={attachments}
                        variant="compose"
                        onRemove={() => this.removeAttachment(item)}
                      />
                    ))}
                  </div>
                </div>
              )}
              <div className="editor-wrapper">
                <ComposeMessageEditor
                  editorRef={this.editorRef}
                  onChange={this.handleEditorChange}
                  defaultValue={content}
                  userId={this.props.lexon.userId}
                  containerPanelRef={this.containerPanelRef}
                  attachmentWrapperRef={this.attachmentWrapperRef}
                  headerFormRef={this.headerFormRef}
                />
              </div>
            </div>
          </div>
          <input
            ref={r => (this.fileInput = r)}
            id="file-input"
            type="file"
            name="name"
            style={{ display: 'none' }}
            multiple={true}
          />
        </div>
      </Fragment>
    );
  }

  validateExistingData(recipient, recipients) {
    const existingData = recipients.some(x => x === recipient.address);
    return existingData;
  }

  getMessageById(selectedMessage) {
    const toRecipients = selectedMessage.recipients.filter(
      x => x.type === 'To'
    );

    const ccRecipients = selectedMessage.recipients.filter(
      x => x.type === 'Cc'
    );

    const bccRecipients = selectedMessage.recipients.filter(
      x => x.type === 'Bcc'
    );

    const editedMessageTo =
      this.props.editedMessage && this.props.editedMessage.to
        ? this.props.editedMessage.to
        : [];
    const editedMessageCc =
      this.props.editedMessage && this.props.editedMessage.cc
        ? this.props.editedMessage.cc
        : [];
    const editedMessageBcc =
      this.props.editedMessage && this.props.editedMessage.bcc
        ? this.props.editedMessage.bcc
        : [];

    const subject = selectedMessage.subject;

    toRecipients.forEach(toRecipient => {
      const existingData = this.validateExistingData(
        toRecipient,
        editedMessageTo
      );
      if (!existingData) {
        setTimeout(() => {
          this.addAddress('to', toRecipient.address);
        }, 100);
      }
    });

    ccRecipients.forEach(ccRecipient => {
      const existingData = this.validateExistingData(
        ccRecipient,
        editedMessageCc
      );
      if (!existingData) {
        setTimeout(() => {
          this.addAddress('cc', ccRecipient.address);
        }, 100);
      }
    });

    bccRecipients.forEach(bccRecipient => {
      const existingData = this.validateExistingData(
        bccRecipient,
        editedMessageBcc
      );
      if (!existingData) {
        setTimeout(() => {
          this.addAddress('bcc', bccRecipient.address);
        }, 100);
      }
    });

    this.getSubjectEdit(subject);

    if (
      (this.props.application.selectedFolderId &&
        this.props.application.selectedFolderId ===
          this.props.draftFolderbyName.folderId) ||
      (this.props.application.selectedFolderId &&
        this.props.draftFolderbyAttribute &&
        this.props.application.selectedFolderId ===
          this.props.draftFolderbyAttribute.folderId)
    ) {
      this.setState({ draftId: selectedMessage.messageId });
    }
  }

  replaceBlobs = async html =>
    new Promise(resolve => {
      const fetchAsBlob = url =>
        fetch(url)
          .then(response => response.blob())
          .catch(err => {
            console.error(err.message);
          });

      const convertBlobToBase64 = blob =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onerror = reject;
          reader.onload = () => {
            resolve(reader.result);
          };
          reader.readAsDataURL(blob);
        });

      const div = document.createElement('div');
      div.innerHTML = html;

      const imgs = div.querySelectorAll('img');
      imgs.forEach((img, i) => {
        const oldVal = img.getAttribute('src');
        if (oldVal !== null && oldVal.includes('blob:')) {
          fetchAsBlob(oldVal)
            .then(convertBlobToBase64)
            .then(value => {
              html = html.replace(oldVal, value);
              if (i === imgs.length - 1) {
                resolve(html);
              }
            })
            .catch(() => {
              resolve(html);
            });
        } else if (i === imgs.length - 1) {
          resolve(html);
        }
      });
      if (imgs.length === 0 || !html.includes('blob:')) {
        resolve(html);
      }
    });

  async submit() {
    const { credentials, to, cc, bcc, subject, lexon } = this.props;
    if (Array.isArray(to) && to.length === 0) {
      this.setState({ showEmptyDestintationWarning: true });
      return;
    }
    if (subject === '' && !this.state.allowEmptySubject) {
      this.setState({ showEmptySubjectWarning: true });
      return;
    }
    if (this.headerFormRef.current.reportValidity()) {
      this.setState({
        showSpinner: true
      });
      this.sendingMessage = true;
      const content = await this.replaceBlobs(this.editorRef.current.value);
      this.props.setInterveners(null);
      this.props.setSubjectEmail('');
      this.props.setIsCompose(false);
      window.dispatchEvent(new CustomEvent('CloseComposer'));
      this.props.sendMessage(credentials, lexon, {
        ...this.props.editedMessage,
        to,
        cc,
        bcc,
        subject,
        content,
        important: this.state.isPriority,
        readConfirmation: this.state.readConfirmation,
        receiptConfirmation: this.state.receiptConfirmation
      });
    }
  }

  getTimeDraft() {
    const date = new Date();
    const time = moment(date).format('HH:mm');
    return time;
  }

  async saveDraft() {
    if (this.headerFormRef.current.reportValidity()) {
      const content = await this.replaceBlobs(this.editorRef.current.value);
      const { user, credentials, to, cc, bcc, subject } = this.props;
      const { draftFolderbyAttribute, draftFolderbyName } = this.props;
      const draftFolder = draftFolderbyAttribute
        ? draftFolderbyAttribute
        : draftFolderbyName;
      if (this.state.draftId !== '') {
        this.props.saveDraft(draftFolder, user, credentials, {
          ...this.props.editedMessage,
          to,
          cc,
          bcc,
          subject,
          content,
          important: this.state.isPriority,
          readConfirmation: this.state.readConfirmation,
          receiptConfirmation: this.state.receiptConfirmation
        });
      } else {
        this.props.saveDraft(draftFolder, user, credentials, {
          ...this.props.editedMessage,
          to,
          cc,
          bcc,
          subject,
          content,
          important: this.state.isPriority,
          readConfirmation: this.state.readConfirmation,
          receiptConfirmation: this.state.receiptConfirmation
        });
      }
      this.setState({
        showSpinner: true,
        closeButton: false
      });
    }
  }

  removeDraft() {
    const {
      credentials,
      selectedMessageEdit,
      application,
      draftFolderbyAttribute,
      draftFolderbyName
    } = this.props;

    const draftFolder = draftFolderbyAttribute
      ? draftFolderbyAttribute
      : draftFolderbyName;

    this.props.deleteMessage(credentials, draftFolder, selectedMessageEdit, this.props.lexon);
    this.props.draftClean();
    this.props.messageClean();
    this.props.close(application);
  }
  /**
   * Adds an address to the list matching the id.
   *
   * @param id
   * @param address
   */
  addAddress(id, address) {
    if (address.length > 0 && id !== 'lexon') {
      const updatedMessage = { ...this.props.editedMessage };
      updatedMessage[id] = [...updatedMessage[id], address];
      this.props.editMessage(updatedMessage);
    } else {
      const localInterveners = [...(this.state.localInterveners || [])];
      localInterveners.push(address);
      this.setState({ localInterveners: localInterveners });
    }
  }
  /**
   * Removes the address from the under the field matching the id.
   *
   * @param id
   * @param address
   */
  removeAddress(id, address) {
    if (id !== 'lexon') {
      const updatedMessage = { ...this.props.editedMessage };
      updatedMessage[id] = [...updatedMessage[id]];
      updatedMessage[id].splice(updatedMessage[id].indexOf(address), 1);
      this.props.editMessage(updatedMessage);
    } else {
      const localInterveners = [...(this.state.localInterveners || [])];
      localInterveners.splice(localInterveners.indexOf(address), 1);
      this.setState({ localInterveners: localInterveners });
    }
  }
  /**
   * Moves an address from the address list under the field matching the fromId to the address field
   * matching the toId.
   *
   * @param fromId
   * @param toId
   * @param address
   */
  moveAddress(fromId, toId, address) {
    const updatedMessage = { ...this.props.editedMessage };
    updatedMessage[toId] = [
      ...updatedMessage[toId],
      fromId === 'lexon' ? address.split(',')[2].replace(/ /g, '') : address
    ];
    this.props.editMessage(updatedMessage);
  }

  getSubjectEdit(value) {
    const updatedMessage = { ...this.props.editedMessage };
    this.props.editMessage({ ...updatedMessage, subject: value });
  }

  addAttachments(attachments) {
    const updatedMessage = { ...this.props.editedMessage };
    this.props.editMessage({ ...updatedMessage, attachments: attachments });
  }

  updateAttachmentLinks(id) {
    const updatedMessage = { ...this.props.editedMessage };
    if (updatedMessage.attachments) {
      updatedMessage.attachments.forEach((attachment, i) => {
        if (attachment._links) {
          const link = attachment._links.download.href.replace(
            /(\/messages\/\d+\/attachments\/)/gm,
            `/messages/${id}/attachments/`
          );
          updatedMessage.attachments[i]._links.download.href = link;
        }
      });
    }
    this.props.editMessage({ ...updatedMessage });
  }

  onSubjectChange(event) {
    const target = event.target;
    const updatedMessage = { ...this.props.editedMessage };
    this.setState({ allowEmptySubject: false });
    this.props.editMessage({ ...updatedMessage, subject: target.value });
  }

  showNotification(message, error = false, align = 'center') {
    this.setState({
      messageNotification: message,
      errorNotification: error,
      notificationAlign: align,
      showNotification: true
    });
  }

  showMaxFileSizeNotification() {
    this.showNotification(
      (
        <div className="text-center">
          <strong className="font-weight-bold">
            {i18n.t('messageEditor.max-file-size')}
          </strong>
          <span className="ml-1">{i18n.t('messageEditor.max-file-size-detail')}</span>
        </div>
      ),
      false,
      'left'
    );
  }

  onDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ dropZoneActive: false });
    const droppedFiles = Array.from(event.dataTransfer.files || []);

    if (droppedFiles.some(file => !this.typeAllowed(file))) {
      this.showNotification(i18n.t('messageEditor.forbidden-extension'), false);
      return;
    }

    const addAttachment = (file, dataUrl) => {
      const newAttachment = {
        fileName: file.name,
        size: file.size,
        contentType: file.type,
        content: dataUrl.currentTarget.result.replace(/^data:[^;]*;base64,/, '')
      };
      const updatedMessage = { ...this.props.editedMessage };
      updatedMessage.attachments = updatedMessage.attachments
        ? [...updatedMessage.attachments, newAttachment]
        : [newAttachment];
      const sum = updatedMessage.attachments.reduce(
        (accumulator, attachment) => accumulator + attachment.size,
        0
      );

      if (sum >= MAX_TOTAL_ATTACHMENTS_SIZE) {
        this.showMaxFileSizeNotification();
        return;
      }

      this.props.editMessage(updatedMessage);
    };
    // Check file sizes
    const sum = droppedFiles.reduce(
      (accumulator, file) => accumulator + file.size,
      0
    );

    if (sum >= MAX_TOTAL_ATTACHMENTS_SIZE) {
      this.showMaxFileSizeNotification();
      return;
    }

    droppedFiles.forEach(file => {
      const fileReader = new FileReader();
      fileReader.onload = addAttachment.bind(this, file);
      fileReader.readAsDataURL(file);
    });
    return;
  }

  onDragOver(event) {
    event.preventDefault();
    if (
      event.dataTransfer.types &&
      Array.from(event.dataTransfer.types).includes('Files')
    ) {
      this.setState({ dropZoneActive: true });
    }
  }

  onDragLeave(event) {
    event.preventDefault();
    this.setState({ dropZoneActive: false });
  }

  removeAttachment(attachment) {
    const updatedMessage = { ...this.props.editedMessage };
    if (updatedMessage.attachments && updatedMessage.attachments.length) {
      updatedMessage.attachments = updatedMessage.attachments.filter(
        a => a !== attachment
      );
      this.props.editMessage(updatedMessage);
    }
  }

  onAttachButton() {
    return this.fileInput && this.fileInput.click();
  }

  onAttachSelected(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ dropZoneActive: false });
    const selectedFiles = Array.from(event.target.files || []);

    if (selectedFiles.some(file => !this.typeAllowed(file))) {
      this.showNotification(i18n.t('messageEditor.forbidden-extension'), false);
      return;
    }

    const addAttachment = (file, dataUrl) => {
      const newAttachment = {
        fileName: file.name,
        size: file.size,
        contentType: file.type,
        content: dataUrl.currentTarget.result.replace(/^data:[^;]*;base64,/, '')
      };
      const updatedMessage = { ...this.props.editedMessage };
      updatedMessage.attachments = updatedMessage.attachments
        ? [...updatedMessage.attachments, newAttachment]
        : [newAttachment];
      const sum = updatedMessage.attachments.reduce(
        (accumulator, attachment) => accumulator + attachment.size,
        0
      );

      if (sum >= MAX_TOTAL_ATTACHMENTS_SIZE) {
        this.showMaxFileSizeNotification();
        return;
      }

      this.props.editMessage(updatedMessage);
    };

    // Check file sizes
    const sum = selectedFiles.reduce(
      (accumulator, file) => accumulator + file.size,
      0
    );
    if (sum >= MAX_TOTAL_ATTACHMENTS_SIZE) {
      this.showMaxFileSizeNotification();
      return;
    }

    selectedFiles.forEach(file => {
      const fileReader = new FileReader();
      fileReader.onload = addAttachment.bind(this, file);
      fileReader.readAsDataURL(file);
    });
    return;
  }

  /**
   * Every change in the editor will trigger this method.
   *
   * For performance reasons, we'll only persist the editor content every EDITOR_PERSISTED_AFTER_CHARACTERS_ADDED
   *
   * @param content
   */
  editorChange(content) {
    if (content && content !== this.lastEditorContent) {
      this.lastEditorContent = content;
      this.props.editMessage({ ...this.props.editedMessage, content: content });
      this.schedulePersistContent(content);
    }
  }

  /**
   * Persisting encrypts the whole HTML (inline Base64 images included) in a worker, so it is
   * debounced to avoid stacking one worker per change/blur event with multi-MB payloads.
   */
  schedulePersistContent(content) {
    clearTimeout(this.persistTimer);
    this.persistTimer = setTimeout(() => {
      persistApplicationNewMessageContent(this.props.application, content);
    }, PERSIST_DEBOUNCE_MS);
  }
}

MessageEditor.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func
};

MessageEditor.defaultProps = {
  className: '',
  t: i18n.t.bind(i18n)
};

const mapStateToProps = state => ({
  application: state.application,
  folders: state.folders,
  draft: state.application.draft,
  selectedMessageEdit: state.application.selectedMessage,
  credentials: getCredentials(state),
  editedMessage: state.application.newMessage,
  interveners: state.lexon.interveners,
  subjectEmail: state.lexon.subjectEmail,
  to:
    state.application.newMessage && state.application.newMessage.to
      ? state.application.newMessage.to
      : [],
  cc:
    state.application.newMessage && state.application.newMessage.cc
      ? state.application.newMessage.cc
      : [],
  bcc:
    state.application.newMessage && state.application.newMessage.bcc
      ? state.application.newMessage.bcc
      : [],
  attachments:
    state.application.newMessage && state.application.newMessage.attachments
      ? state.application.newMessage.attachments
      : [],
  subject:
    state.application.newMessage && state.application.newMessage.subject
      ? state.application.newMessage.subject
      : '',
  editor:
    state.application.newMessage && state.application.newMessage.editor
      ? state.application.newMessage.editor
      : null,
  content:
    state.application.newMessage && state.application.newMessage.content
      ? state.application.newMessage.content
      : null,
  getAddresses: value => getAddresses(value, state.messages.cache),
  lexon: state.lexon,
  user: state.application.user,
  currentUser: state.currentUser,
  msgCache: state.messages.cache,
  draftFolderbyName: Object.values(state.folders.explodedItems).find(
    folder =>
      folder &&
      folder.name &&
      (folder.name.toUpperCase() === 'DRAFTS' ||
        folder.name.toUpperCase() === 'BORRADORES' ||
        folder.name.toUpperCase() === 'BORRADOR' ||
        folder.name.toUpperCase() === 'ESBORRANYS')
  ),
  draftFolderbyAttribute: Object.values(state.folders.explodedItems).find(
    folder =>
      folder &&
      folder.name &&
      folder.attributes.find(att => att && att.toUpperCase() === '\\DRAFTS')
  )
});

const mapDispatchToProps = dispatch => ({
  close: application => {
    dispatch(editMessage(null));
    persistApplicationNewMessageContent(application, '');
  },
  editMessage: message => {
    dispatch(editMessage(message));
  },
  messageClean: () => {
    dispatch(selectMessage({}));
  },
  draftClean: () => {
    dispatch(draftClean());
  },
  sendMessage: (
    credentials,
    lexon,
    {
      inReplyTo,
      references,
      to,
      cc,
      bcc,
      attachments,
      subject,
      content,
      important,
      readConfirmation,
      receiptConfirmation
    }
  ) =>
    sendMessage(dispatch, credentials, lexon, {
      inReplyTo,
      references,
      to,
      cc,
      bcc,
      attachments,
      subject,
      content,
      important,
      readConfirmation,
      receiptConfirmation
    }),
  saveDraft: (
    draftFolder,
    user,
    credentials,
    {
      inReplyTo,
      references,
      to,
      cc,
      bcc,
      attachments,
      subject,
      content,
      important,
      readConfirmation,
      receiptConfirmation
    }
  ) => {
    saveDraft(dispatch, credentials, {
      inReplyTo,
      references,
      to,
      cc,
      bcc,
      attachments,
      subject,
      content,
      important,
      readConfirmation,
      receiptConfirmation
    });
  },
  setCaseFile: casefile => dispatch(ACTIONS.setCaseFile(casefile)),
  setMailContacts: mailContacts =>
    dispatch(ACTIONS.setMailContacts(mailContacts)),
  deleteMessage: (credentials, selectedFolder, selectedMessage, lexon) => {
    deleteMessages(dispatch, credentials, selectedFolder, [selectedMessage], lexon);
  },
  setDocumentsId: documentsId => dispatch(ACTIONS.setDocumentsId(documentsId)),
  reloadFolders: credentials => getFolders(dispatch, credentials, true),
  reloadMessageCache: (user, folder) =>
    resetFolderMessagesCache(dispatch, user, folder),
  selectMessage: message => {
    dispatch(selectMessage(message));
  },
  setShowUserSignPopover: showUserSignPopover =>
    dispatch(setShowUserSignPopover(showUserSignPopover)),
  setShowUserTemplatePopover: showUserTemplatePopover =>
    dispatch(setShowUserTemplatePopover(showUserTemplatePopover)),
  setInterveners: interveners => dispatch(ACTIONS.setInterveners(interveners)),
  setSubjectEmail: subject => dispatch(ACTIONS.setSubjectEmail(subject)),
  setIsCompose: isCompose => dispatch(ACTIONS.setIsCompose(isCompose))
});

const ConnectedMessageEditor = connect(
  mapStateToProps,
  mapDispatchToProps
)(MessageEditor);

export default ConnectedMessageEditor;
